import type { ComputedRef } from 'vue'
import {
  usarCatalogoQuery,
  usarContextoCatalogo,
  type EstadoCatalogoQuery,
} from '@next/compartilhados/catalogos'

import {
  DESCRITOR_CATALOGO_REGRA_DE_CALCULO,
  type OpcaoRegraDeCalculo,
} from '../catalogo-regra-de-calculo.tipos'
import { usarOperacoesCatalogoRegraDeCalculo } from './catalogo-regra-de-calculo.injecao'

export const usarCatalogoRegraDeCalculo = (
  habilitado?: ComputedRef<boolean>,
): EstadoCatalogoQuery<OpcaoRegraDeCalculo> => {
  const operacoes = usarOperacoesCatalogoRegraDeCalculo()
  return usarCatalogoQuery({
    catalogo: DESCRITOR_CATALOGO_REGRA_DE_CALCULO,
    contexto: usarContextoCatalogo(),
    consultar: operacoes.listarOpcoes,
    ...(habilitado ? { habilitado } : {}),
  })
}
